<template>
  <div>
    <el-form ref="formData" :model="formData" size="small">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.order_package_packageType') || '包装类型'"
          >
            <el-input v-model="formData.v_packageType" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="
              $l('INDEX.form_label_detail_material_category') || '2级物料分类'
            "
          >
            <el-input v-model="formData.detailMaterialCategoryName" readonly>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.order_package_materialNo') || '包装编号'"
          >
            <el-input v-model="formData.materialNo" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.order_package_materialName') || '物料名称'"
          >
            <el-input v-model="formData.materialName" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_package_boxLength') || '包装箱长(cm)'"
          >
            <el-input v-model="formData.boxLength" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_package_boxWidth') || '包装箱宽(cm)'"
          >
            <el-input v-model="formData.boxWidth" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_package_boxHeight') || '包装箱高(cm)'"
          >
            <el-input v-model="formData.boxHeight" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.order_package_boxWeight') || '包装箱重量(g)'"
          >
            <el-input v-model="formData.boxWeight" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.order_package_isSpecify') || '客户指定供应商'"
          >
            <el-input v-model="formData.v_isSpecify" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.purchase_form_label_scmCode') || '供应商'"
          >
            <el-input v-model="formData.scmName" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="
              $l('INDEX.order_form_label_isCustomerProvide') || '客户指定供应商'
            "
          >
            <el-input v-model="formData.v_isCustomerProvide" readonly>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  props: { orderPackageCode: { type: String, default: '' } },
  data() {
    return {
      formData: {},
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderPackageCode) return
      this.$api
        .pendingOrderDemandPackageDetailApi({
          orderPackageCode: this.orderPackageCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
  },
}
</script>
